<!--带图标的select  tree-->
<template>
  <!--  <el-tree-select v-bind="$props" v-model="bindValue" filterable>-->
  <!--    <template #default="{ node, data }">-->
  <!--      <i :class="getTreeIcon(node, data)" :style="{width: 8 + 'px', height: 8 + 'px'}"/>-->
  <!--      {{ props?.label ? data[this.props.label] : data.label }}-->
  <!--    </template>-->
  <!--  </el-tree-select>-->
  <avue-input-tree v-model="bindValue" default-expand-all :placeholder="placeholder" :dic="data" :props="props" />
</template>

<script>

export default {
  name: 'DyTreeSelect',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String
    },
    data: {
      type: [Array]
    },
    props: {
      type: [Object, undefined]
    }
    // ...ElTreeSelect.props
  },
  computed: {
    bindValue: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    getTreeIcon(node, data) {
      switch (this.iconType) {
        case 'OrgProject':
          if (node.level === 1) return 'icon-company'
          if (data.attr.orgType === 'project') return 'icon-line-communityshequ'
          return 'icon-xitongguanli-bumenguanli'
        case 'ChargeType':
          return 'icon-shoufeixiangmu'
        case 'ChargeAccount':
          return data.type === '0' ? 'icon-zuheshoufeixiangmuguanli' : 'icon-shoufeixiangmu'
        default:
          return 'icon-xitongguanli-bumenguanli'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dy-project-select-tree {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  .dy-tree {
    flex: 1;
    overflow: auto;
  }
}

</style>
